const BASE = process.env.NODE_ENV === 'production' ? '' : '';

async function req(method, url, body) {
  const opts = { method, headers: { 'Content-Type': 'application/json' } };
  if (body) opts.body = JSON.stringify(body);
  const res = await fetch(BASE + url, opts);
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw Object.assign(new Error(err.error || 'Error'), { status: res.status });
  }
  return res.json();
}

const QUEUE_KEY = 'inv_queue';

function getQueue()    { try { return JSON.parse(localStorage.getItem(QUEUE_KEY) || '[]'); } catch { return []; } }
function saveQueue(q)  { localStorage.setItem(QUEUE_KEY, JSON.stringify(q)); }
function clearQueue()  { localStorage.removeItem(QUEUE_KEY); }

async function queuedMutation(method, url, body) {
  if (navigator.onLine) return req(method, url, body);
  const q = getQueue();
  q.push({ method, url, body, at: Date.now() });
  saveQueue(q);
  return { _offline: true, ...(body || {}) };
}

export const api = {
  /* Categories */
  getCategories:    ()         => req('GET',    '/api/categories'),
  createCategory:   (data)     => req('POST',   '/api/categories', data),
  updateCategory:   (id, data) => req('PUT',    `/api/categories/${id}`, data),
  deleteCategory:   (id)       => req('DELETE', `/api/categories/${id}`),

  /* Products */
  getProducts:      (q, cat)   => req('GET', `/api/products${q||cat ? '?'+(q?'q='+encodeURIComponent(q):'')+(q&&cat?'&':'')+(cat?'cat='+cat:'') : ''}`),
  getByBarcode:     (code)     => req('GET', `/api/products/barcode/${encodeURIComponent(code)}`),
  getStats:         ()         => req('GET', '/api/products/stats'),
  sync:             (since)    => req('GET', `/api/products/sync${since?'?since='+encodeURIComponent(since):''}`),
  createProduct:    (data)     => queuedMutation('POST',  '/api/products',      data),
  updateProduct:    (id, data) => queuedMutation('PUT',   `/api/products/${id}`, data),
  deleteProduct:    (id)       => req('DELETE', `/api/products/${id}`),

  /* Image upload */
  uploadImage: async (file) => {
    const form = new FormData();
    form.append('image', file);
    const res = await fetch(BASE + '/api/upload-image', { method: 'POST', body: form });
    if (!res.ok) throw new Error('Error al subir imagen');
    return res.json();
  },

  /* Settings */
  getSettings:  ()     => req('GET', '/api/settings'),
  saveSettings: (data) => req('PUT', '/api/settings', data),

  /* Flush offline queue */
  flushQueue: async () => {
    const q = getQueue();
    if (!q.length) return;
    let ok = 0;
    for (const item of q) {
      try { await req(item.method, item.url, item.body); ok++; } catch (_) { break; }
    }
    if (ok === q.length) clearQueue();
    else saveQueue(q.slice(ok));
  },
};

export default api;
